import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  error: null,
  vehicleStatus: null,
  updateManageVehicleStatusResult: null,
  vehicleStatusIcons: []
};

const route = "modules/manage/modals/createEditManageVehicleStatus/redux/slice";

export const manageVehicleStatusGetIcons = createAsyncThunk(
  "manage/createEditManageVehicleStatus/manageVehicleStatusGetIcons",
  async (_, { rejectWithValue }) => {
    try {
      const query = `
            query searchVehicleStatusIcons ($groupName: String) {
                searchVehicleStatusIcons (groupName: $groupName) {
                    id
                    name
                    iconPath
                    groupName
                }
            }
        `;
      const response = await clientQuery(query, { groupName: "" }, endpoints.GRAPHQL_GENERAL);
      return response?.searchVehicleStatusIcons;
    } catch (exc) {
      ExceptionManager(exc, route, "manageVehicleStatusGetIcons");
      return rejectWithValue(exc);
    }
  }
);

export const manageCreateEditManageVehicleStatus = createAsyncThunk(
  "manage/createEditManageVehicleStatus/manageCreateEditManageVehicleStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const mutation = `
            mutation (
                ${payload.id ? "$id: Int!," : ""}
                ${payload.id ? "$name: String," : "$name: String!"}
                $iconId: Int!
            ) {
                data: ${payload.id ? "updateVehicleStatus" : "createVehicleStatus"} (
                    ${payload.id ? "id: $id," : ""}
                    name: $name,
                    iconId: $iconId
                ) {
                    id
                }
            }
        `;
      const response = await clientMutation(mutation, payload, endpoints.GRAPHQL_GENERAL);
      return response?.data;
    } catch (exc) {
      ExceptionManager(exc, route, "manageCreateEditManageVehicleStatus");
      return rejectWithValue(exc);
    }
  }
);

const manageCreateEditManageVehicleStatusRedux = createSlice({
  name: "manage/createEditManageVehicleStatus",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
    },
    openModalCreateEditManageVehicleStatus(state, action) {
      state.open = true;
      state.vehicleStatus = action?.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageVehicleStatusGetIcons
    builder.addCase(manageVehicleStatusGetIcons.pending, (state) => {
      state.loading = true;
      state.vehicleStatusIcons = [];
    });
    builder.addCase(manageVehicleStatusGetIcons.fulfilled, (state, action) => {
      state.loading = false;
      state.vehicleStatusIcons = action.payload;
    });
    builder.addCase(manageVehicleStatusGetIcons.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //manageCreateEditManageVehicleStatus
    builder.addCase(manageCreateEditManageVehicleStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageCreateEditManageVehicleStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.updateManageVehicleStatusResult = action.payload;
    });
    builder.addCase(manageCreateEditManageVehicleStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageCreateEditManageVehicleStatusRedux;

// Extract and export each action creator by name
export const { reset, openModalCreateEditManageVehicleStatus } = actions;

// Export the reducer, either as a default or named export
export default reducer;
